module.exports = __webpack_public_path__ + "static/media/image8.2452a3d5.jpeg";